exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr th[data-v-0100163b]:not(:first-child) {\n\tfont-weight: 500;\n\ttext-align: left;\n\tborder-bottom: 1px solid black;\n}\ntable tr[data-v-0100163b]:nth-child(even) {\n\tbackground: #f5f5f5;\n}\ntd[data-v-0100163b],\nth[data-v-0100163b] {\n\tpadding: 10px;\n}\n", ""]);

// exports
